import React from 'react'

const LiveAction = () => (
  <div>
    <div className="row width-container center-image">
    <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/LXuGqoziq-U"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/yAwr5YdLpIk"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/_nJYg7G_C2g"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/JuGS3gY9muY"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/Uetnzbbjdbc"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/RIctgmUwJLs"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/ivezBCvhIzA"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/m3P5v4CbWvM"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/hD4pEY0FV_A"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/eLmSU3R5bI8"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/qKNf-1DSMvE"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/IjMqmfZjcm8"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/mzcqh5tcDfw"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/aON2gHRUeHs"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/7RIfFtadghc"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  </div>
)

export default LiveAction





// WEBPACK FOOTER //
// ./src/pages/animation/live-action.js